<template>
  <div>
    <nav-bar ref="form"/>
    <div class="sec-wight-bg py-16 ">
      <div class="container sec-garay-bg border-radius ">
        <div class="row ">
          <h5 class="text-blue col py-0">
            <page-title :titles="'مشتریان ما'"/>
          </h5>
        </div>
      </div>
      <div class="container p-0" dir="ltr">
        <div class="row">
          <div class="col-12 col-md-3 " v-for="item in Customers" :key="item.id">
            <a :href="item.link" target="_blank">
              <div class="sec-garay-bg  p-4">
                <v-img :src="$replaceHttps(item.imageUrl)" class="mx-auto" width="150"
                       height="150">>
                </v-img>
              </div>
              <div class="bg-product-btn white--text text-center  py-4">{{item.title}}</div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <footer-menu/>
    <v-overlay
        id="searchOverLay"
        :absolute="false"
        :color="'#f7f1fc'"
        :opacity="0.7"
        :value="showLoaderDialog"
        :z-index="6">
      <div class="row h-100 align-items-center justify-content-center">
        <div class="loading-spinner">
        </div>
      </div>
    </v-overlay>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import PageTitle from "@/components/titles";
import FooterMenu from "@/components/footer";

export default {
  name: "OurCustomers",
  components: {FooterMenu, PageTitle, NavBar},
  data: () => ({
    showLoaderDialog: false,
    isPageLoaded: false,
    Customers: [],
  }),

  mounted() {
    this.getData()
  },
  methods: {
    getImgUrl(pic) {

      return require("../assets/img/" + pic);
    },

    getData() {
      this.showLoaderDialog = true;
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "Home/Index", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.isPageLoaded = true
            let json = JSON.parse(result)
            console.log(json)

            this.banner = json.banners.filter(x => x.isActive === true)
            console.log('...', this.banner)
            this.Services = json.services.filter(x => x.isActive === true)
            this.Customers = json.customers.filter(x => x.isActive === true)
            console.log("this.Customers")
            console.log(this.Customers)
            this.Products = json.products.filter(x => x.isActive === true)

            console.log(json.products.filter(x => x.isActive === true))
            this.latestBlogPosts = json.latestBlogPosts.filter(x => x.isActive === true)
            this.showLoaderDialog = false;
          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>

<style scoped>

</style>